import React from 'react';
import { ReferralSignUpInput } from '../ReferralSignUpInput';

export const ClabeInput = ({ t, errors, touched, params }) => {
  return <ReferralSignUpInput name={params.clabeInput.name} label={t(params.clabeInput.labelText)} placeholder={t(params.clabeInput.placeholder)} errors={errors} touched={touched} />;
};
